"use strict";
// _partialFile.js

{
document.addEventListener("DOMContentLoaded", () => {
  const links = document.querySelectorAll(".p-categories__itemTitle");
  const cards = document.querySelectorAll(".p-card");

  links.forEach((link) => {
    link.addEventListener("click", (e) => {
      const href = link.getAttribute("href") || "";
      if (href !== "#" && href !== "") {
        return;
      }
      e.preventDefault();

      // 選択中のカテゴリを取得
      const genre = link.dataset.genre || "";

      // is-current の付け替え
      links.forEach((l) => l.parentElement.classList.remove("is-current"));
      link.parentElement.classList.add("is-current");

      // カードの表示切替
      cards.forEach((card) => {
        if (genre === "" || card.dataset.genre === genre) {
          card.style.display = "";
        } else {
          card.style.display = "none";
        }
      });
    });
  });
});
  
}
